<template functional>
	<div class="content-loader" :class="{ cover: props.cover !== false }">
		<div class="content-loader-body">
			<b-spinner class="content-loader-spinner" small variant="secondary" />
			{{ props.message }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		offset: { default: true },
		cover: { default: false },
		message: {
			type: String,
			required: true
		}
	}
};
</script>

<style lang="scss">
	@use "sass:math";
	@import '../variables';
	@import '../mixins';

	.content-loader {
		&.cover {
			position: fixed;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			z-index: 9999;
			background-color: rgba($dark-gray, 0.8);

			.content-loader-body {
				margin-left: 0;
			}
		}

		.content-loader-body {
			position: fixed;
			top: 50%;
			left: 50%;
			margin-left: math.div(($app-sidebar-collapsed-width + $section-sidebar-width), 2);
			transform: translate(-50%, -50%);
			padding: 15px;
			background-color: white;
			border-radius: 5px;
			@include card(2);
			z-index: 2000;

			.content-loader-spinner {
				vertical-align: middle;
				margin-right: 10px;
			}
		}
	}
</style>
